import React from "react";
import classnames from "classnames";
import styles from "./card.module.css";

const Card = ({
  children,
  title,
  className = "",
  bodyClass = "",
  style,
  onClick,
  childComponent,
}) => (
  <div
    className={`col col-sm-11 text-left ${styles["dashboard-card"]} ${className}`}
    style={{ ...style }}
    onClick={onClick}
  >
    <div className={classnames(`p-0 mt-3 ${styles["content"]}`, bodyClass)}>
      {title && (
        <h6 className={classnames("header text-left mb-5 mt-n4")}>{title}</h6>
      )}
      {childComponent && (
        childComponent
      )}
      {children}
    </div>
  </div>
);

export default Card;
